import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface ArticlePreview {
  titleKey: string;
  descKey: string;
  imageUrl: string;
  imageAlt: string;
  linkTo: string;
}

const articles: ArticlePreview[] = [
  {
    titleKey: "blog.article1.title",
    descKey: "blog.article1.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20overhead%20shot%20of%20white%20leather%20sneakers%20with%20shopping%20bag%20tissue%20paper%20and%20receipt%20neatly%20arranged%20on%20warm%20cream%20linen%20surface%20soft%20natural%20window%20light%20editorial%20product%20photography%20with%20organic%20elegance%20and%20gentle%20shadows&width=800&height=560&seq=blog-card-1-fresh-v3&orientation=landscape",
    imageAlt: "Guia Hoobuy Sheet",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article2.title",
    descKey: "blog.article2.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Artistic%20flatlay%20of%20two%20different%20style%20sneakers%20side%20by%20side%20comparison%20one%20minimalist%20cream%20leather%20one%20casual%20beige%20canvas%20on%20warm%20neutral%20backdrop%20soft%20daylight%20clean%20editorial%20aesthetic%20with%20comparison%20tags%20and%20organic%20composition&width=800&height=560&seq=blog-card-2-fresh-v3&orientation=landscape",
    imageAlt: "Comparação Hoobuyspreadsheet",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article3.title",
    descKey: "blog.article3.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20photography%20of%20shopping%20essentials%20including%20smartphone%20displaying%20shopping%20app%20credit%20card%20small%20gift%20box%20and%20coffee%20cup%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20clean%20editorial%20style%20with%20organic%20shadows&width=800&height=560&seq=blog-card-3-fresh-v3&orientation=landscape",
    imageAlt: "Dicas de compra Hoobuy",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article4.title",
    descKey: "blog.article4.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Top%20down%20flatlay%20of%20premium%20cream%20leather%20sneakers%20with%20detailed%20stitching%20surrounded%20by%20shoe%20care%20accessories%20soft%20brush%20polish%20cloth%20on%20warm%20beige%20linen%20surface%20soft%20natural%20diffused%20daylight%20editorial%20product%20photography%20with%20refined%20elegance&width=800&height=560&seq=blog-card-4-fresh-v3&orientation=landscape",
    imageAlt: "Guia de Tênis Hoobuy",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article5.title",
    descKey: "blog.article5.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Conceptual%20security%20themed%20flatlay%20with%20magnifying%20glass%20over%20smartphone%20screen%20showing%20shopping%20website%20lock%20icon%20and%20shield%20symbol%20on%20warm%20cream%20linen%20surface%20soft%20natural%20lighting%20clean%20editorial%20composition%20conveying%20trust%20and%20safety%20online&width=800&height=560&seq=blog-card-5-fresh-v3&orientation=landscape",
    imageAlt: "Links Falsos Hoobuy",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article6.title",
    descKey: "blog.article6.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Curated%20flatlay%20of%20premium%20product%20samples%20including%20small%20leather%20goods%20watch%20box%20folded%20garment%20and%20accessories%20arranged%20in%20neat%20grid%20pattern%20on%20warm%20oatmeal%20linen%20surface%20soft%20daylight%20editorial%20catalog%20photography%20with%20refined%20minimalism&width=800&height=560&seq=blog-card-6-fresh-v3&orientation=landscape",
    imageAlt: "Fornecedores Confiáveis Hoobuy",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article7.title",
    descKey: "blog.article7.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20desk%20scene%20with%20open%20notebook%20handwritten%20tips%20sticky%20notes%20and%20laptop%20showing%20spreadsheet%20on%20warm%20cream%20surface%20soft%20natural%20window%20light%20creating%20gentle%20shadows%20clean%20productive%20aesthetic%20with%20organic%20warmth&width=800&height=560&seq=blog-card-7-fresh-v3&orientation=landscape",
    imageAlt: "Erros Iniciantes Hoobuy",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article8.title",
    descKey: "blog.article8.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Flatlay%20of%20measuring%20tape%20wrapped%20around%20folded%20cream%20sweater%20with%20size%20chart%20paper%20and%20fabric%20swatches%20on%20warm%20sand%20linen%20surface%20soft%20natural%20daylight%20clean%20editorial%20product%20photography%20with%20practical%20elegant%20composition&width=800&height=560&seq=blog-card-8-fresh-v3&orientation=landscape",
    imageAlt: "Guia de Tamanhos Hoobuy",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article9.title",
    descKey: "blog.article9.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20flatlay%20of%20multiple%20price%20tags%20with%20descending%20values%20calculator%20and%20small%20gift%20boxes%20on%20warm%20cream%20linen%20surface%20soft%20natural%20lighting%20clean%20editorial%20composition%20conveying%20savings%20and%20smart%20shopping%20with%20organic%20sophistication&width=800&height=560&seq=blog-card-9-fresh-v3&orientation=landscape",
    imageAlt: "Economizar Hoobuy",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article10.title",
    descKey: "blog.article10.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20flatlay%20of%20a%20neatly%20folded%20cream%20colored%20sports%20jersey%20with%20subtle%20team%20inspired%20pattern%20on%20warm%20oatmeal%20linen%20surface%20soft%20natural%20daylight%20highlighting%20fabric%20texture%20and%20stitching%20details%20editorial%20product%20photography%20with%20athletic%20elegance&width=800&height=560&seq=blog-card-10-fresh-v3&orientation=landscape",
    imageAlt: "Jersey Hoobuy",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article11.title",
    descKey: "blog.article11.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20minimalist%20accessories%20including%20soft%20leather%20watch%20tan%20belt%20delicate%20chain%20necklace%20and%20beige%20sunglasses%20on%20warm%20cream%20linen%20surface%20soft%20natural%20diffused%20lighting%20clean%20editorial%20product%20photography%20with%20refined%20organic%20composition&width=800&height=560&seq=blog-card-11-fresh-v3&orientation=landscape",
    imageAlt: "Acessórios Hoobuy",
    linkTo: "/guia-hoobuy-sheet",
  },
  {
    titleKey: "blog.article12.title",
    descKey: "blog.article12.desc",
    imageUrl: "https://readdy.ai/api/search-image?query=Trend%20forecasting%20flatlay%20with%20fashion%20mood%20board%20color%20swatches%20in%20warm%20beige%20cream%20and%20terracotta%20tones%20fabric%20samples%20and%20small%20accessories%20on%20oatmeal%20linen%20surface%20soft%20daylight%20editorial%20creative%20composition%20with%20organic%20elegance&width=800&height=560&seq=blog-card-12-fresh-v3&orientation=landscape",
    imageAlt: "Tendências Hoobuy 2026",
    linkTo: "/guia-hoobuy-sheet",
  },
];

export default function BlogPreview() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        {/* Header */}
        <div className="mb-12">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            {t("blog.title1")}
          </h2>
          <h2 className="font-heading text-4xl md:text-5xl italic font-light text-foreground-500 leading-tight">
            {t("blog.title2")}
          </h2>
        </div>

        {/* Cards - 4 columns grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.titleKey}
              to={article.linkTo}
              className="group block rounded-xl border border-background-200/60 overflow-hidden bg-background-50 hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full h-[200px] md:h-[230px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-white/6 group-hover:bg-white/3 transition-colors"></div>
              </div>
              {/* Content */}
              <div className="p-5 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-accent-800 transition-colors leading-snug line-clamp-2">
                  {t(article.titleKey)}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {t(article.descKey)}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-foreground-400 group-hover:text-accent-600 transition-colors whitespace-nowrap">
                  {t("blog.readmore")}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}